



import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";



export const initKfsTataApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    try {
        const response = await axios.post(endpoints.initKfsTata + applicationId);
        return response;
    } catch (error) {
        return error;
    }
}


export const esignInitApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.get(endpoints.esignInit + applicationId);
    return response;
}


export const validateEsignApi = async (payload: {
    applicationId: string;
    widgetToken: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.post(endpoints.validateEsign , { widgetToken: payload.widgetToken , applicationId: applicationId });
    return response;
}


export const pollKfsTataApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.get(endpoints.pollKfsTata + applicationId);
    return response;
}

export const checkEsignStatusTataApi = async (payload: {
    applicationId: string;
}) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id');

    if (applicationIdStored) {
        applicationId = applicationIdStored;
    }
    const response = await axios.get(endpoints.checkEsignStatusTata + applicationId);
    return response;
}